import { reducer as impressionsReducer } from '@nerdwallet/nw-client-lib/tracking';
import { Action, combineReducers } from 'redux';
import builderReducer from './builder';
import authenticationReducer from './authentication';
import loadingReducer from './loading';

export const combinedReducers = combineReducers({
  builder: builderReducer,
  identity: authenticationReducer,
  impressions: impressionsReducer,
  loading: loadingReducer,
});

export default function rootReducer(state = {}, action: Action<string>) {
  return combinedReducers(state, action);
}
